class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".js-tab").each(function(){

      const $wrap = $(this);
      const $tabs = $wrap.find(".js-tab-item");
      const $contents = $wrap.find(".js-tab-content");
    
      $tabs.removeClass("is-active").first().addClass("is-active");
      $contents.hide().first().show();
    
      $tabs.on("click", function(){
    
        const index = $(this).index();
    
        $tabs.removeClass("is-active");
        $(this).addClass("is-active");
    
        $contents.hide().eq(index).show();
    
      });
    
    });

    gsap.registerPlugin(ScrollTrigger);

    const swipers = document.querySelectorAll('.js-parallax-swiper');
    const instances = [];
    swipers.forEach((el) => {
    
      const swiper = new Swiper(el, {
        loop: true,
        effect: "fade",
        speed: 1000,
        allowTouchMove: false,
      });
    
      instances.push(swiper);
    
    });
    
    let index = 0;
    
    setInterval(() => {    
      index++;
      instances.forEach((swiper, i) => {
        const total = swiper.slides.length - swiper.loopedSlides * 2;    
        const targetIndex = (index + i) % total;
        swiper.slideToLoop(targetIndex);
      });
    
    }, 3000);

    gsap.utils.toArray(".js-parallax-img").forEach((el) => {

      const imgs = el.querySelectorAll(".js-parallax-target");
    
      imgs.forEach((img) => {
        gsap.fromTo(
          img,
          {
            yPercent: -60
          },
          {
            yPercent: -40,
            ease: "none",
            scrollTrigger: {
              trigger: el,
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          }
        );
      });
    
    });

    gsap.set([".p-top", ".js-header", ".js-fixed-nav"], {
      opacity: 0
    });
  
    const tl = gsap.timeline();
  
    tl.to({}, { duration: 1 }) // ← ローディングを見せる時間
  
    .to(".js-loading", {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => {
        document.querySelector(".js-loading").classList.add("no-active");
      }
    })
    
    .to([".p-top", ".js-header", ".js-fixed-nav"], {
      opacity: 1,
      duration: 1,
      ease: "power2.out",
      stagger: 0.2,
      onComplete: () => {

        var mvSwiper = new Swiper(".js-mv-swiper", {
          slidesPerView: 1,
          effect: "fade",
          loop: true,
          speed: 2000,
          autoplay: {
            delay: 2000,
            disableOnInteraction: true
          },
        });
    
      }
    }, "-=0.3");

		// let modelhouseSwiper = null;
		// const breakpoint = 768;
	
		// function initSwiper() {
		// 	if ($(window).width() < breakpoint && modelhouseSwiper === null) {
	
		// 		modelhouseSwiper = new Swiper('.js-modelhouse-swiper', {
		// 			slidesPerView: 1.2,
		// 			centeredSlides: true,
		// 			spaceBetween: 10,
		// 			loop: true,
		// 		});
	
		// 	} else if ($(window).width() >= breakpoint && modelhouseSwiper !== null) {
	
		// 		modelhouseSwiper.destroy(true, true);
		// 		modelhouseSwiper = null;
	
		// 	}
		// }
	
		// initSwiper();
	
		// $(window).on('resize', function () {
		// 	initSwiper();
		// });

    let storySwiper;

    function initStorySwiper() {
    
      if (window.innerWidth < 768) {
    
        if (!storySwiper) {
          storySwiper = new Swiper(".js-story-swiper", {
            slidesPerView: 1.2,
            centeredSlides: true,
            loop: true,
            spaceBetween: 10,
            speed: 2000,
          });
        } 
      } else {
    
        if (storySwiper) {
          storySwiper.destroy(true, true);
          storySwiper = undefined;
        }
    
      }
    }
    
    // 🔥 ここ重要
    initStorySwiper();
    
    window.addEventListener("resize", initStorySwiper);
    
		// var mvSwiper = new Swiper(".js-mv-swiper", {
    //   slidesPerView: 1,
    //   effect: "fade",
    //   loop: true,
    //   speed: 1000,
    //   autoplay: {
    //     delay: 2000,
    //     disableOnInteraction: true
    //   },
    // });

		var worksSwiper = new Swiper(".js-works-swiper", {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      spaceBetween: 10,
      speed: 1000,
      navigation: {
        nextEl: '.js-works-next',
        prevEl: '.js-works-prev',
      },
      pagination: {
        el: '.js-works-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 11,
        }
      },
    });

		var modelhouseSwiper = new Swiper(".js-model-swiper", {
			slidesPerView: "auto",
      centeredSlides: true,
			spaceBetween: 10,
			loop: true,
      speed: 1000,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: true
      // },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 8,
        }
      },
      navigation: {
        nextEl: '.js-model-next',
        prevEl: '.js-model-prev',
      },
      pagination: {
        el: '.js-model-pagination',
        clickable: true,
      },
    });
	
    // var interviewSwiper = new Swiper(".js-swiper-interview", {
    //   slidesPerView: 1.4,
    //   centeredSlides: true,
    //   loop: true,
    //   spaceBetween: 16,
    //   speed: 1000,
    //   autoplay: {
    //     delay: 4000,
    //     disableOnInteraction: true
    //   },
    //   breakpoints: {
    //     768: {
    //       centeredSlides: false,
    //       slidesPerView: 3,
    //       spaceBetween: 40,
    //     }
    //   },
    //   pagination: {
    //     el: ".js-swiper-interview-pagination",
    //     clickable: true,
    //   },
    //   navigation: {
    //     nextEl: ".js-swiper-interview-next",
    //     prevEl: ".js-swiper-interview-prev",
    //   },
    // });

    // var loopSwiper = new Swiper(".-loop", {
    //   loop: true,
    //   slidesPerView: "auto",
    //   spaceBetween: 20,
    //   speed: 10000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 0,
    //   },
    //   breakpoints: {
    //     768: {
    //       centeredSlides: false,
    //       slidesPerView: 3,
    //       spaceBetween: 20,
    //     }
    //   }
    // });

  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		$(".js-acc-trigger").on("click", function () {
			$(this).toggleClass("is-active");
			$(this).next(".js-acc-content").slideToggle(200);
		});
	}
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FixedArea {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
		console.log("読み込み");
		
    const navItems = $(".js-fixed-area-item");

    const sections = [];
    navItems.each(function () {
      const target = $($(this).attr("href"));
      if (target.length) {
        sections.push(target);
      }
    });

    $(window).on("scroll", function () {
      const scrollPos = $(window).scrollTop() + $(window).height() / 2;
      // const offset = 150;

      let currentId = "";

      sections.forEach(section => {
        const top = section.offset().top;
        const bottom = top + section.outerHeight();    

        if (scrollPos >= top && scrollPos < bottom) {
          currentId = section.attr("id");
        }
      });

      navItems.each(function () {
        const href = $(this).attr("href").replace("#", "");

        if (href === currentId) {
          $(this).addClass("is-active");
        } else {
          $(this).removeClass("is-active");
        }
      });

    });
  }
}

class Form {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		$(document).on('submit', '.wpcf7-form', function(){
			const hash = window.location.hash;

			if (hash) {
				sessionStorage.setItem('cf7_anchor', hash);
			}
		});

		// 戻った時に復元
		const hash = sessionStorage.getItem('cf7_anchor');

		if (hash) {
			const $target = $(hash);

			if ($target.length) {
				$('html, body').scrollTop($target.offset().top);
			}

			sessionStorage.removeItem('cf7_anchor');
		}

		$(document).on('click', '.p-reservation-confirm .wpcf7-previous', function(e){

			e.preventDefault();
		
			const referer = document.referrer;
			if (!referer) return;
		
			location.href = referer.split('#')[0] + '#c-anchor-form';
		
		});

		$(document).on('wpcf7beforesubmit', function (e) {
			const form = e.target;
		
			// 二重クリック防止（送信直前）
			if ($(form).data('submitting')) {
				e.preventDefault();
				return false;
			}
		
			$(form).data('submitting', true);
		});
		
		$(document).on('wpcf7submit', function (e) {
			const form = e.target;
		
			if (e.originalEvent.detail.status === 'mail_sent') {
				const $btn = $(form).find('[type="submit"]');
		
				$btn.prop('disabled', true).val('送信済み');
			} else {
				$(form).data('submitting', false);
			}
		});

		// $(document).on('submit', '.wpcf7 form', function(e){

		// 	if ($(this).data('submitting')) {
		// 		e.preventDefault();
		// 		return false;
		// 	}
	
		// 	$(this).data('submitting', true);
	
		// 	const $btn = $(this).find('[type="submit"]');
		// 	if ($btn.length) {
		// 		$btn.prop('disabled', true).val('送信中...');
		// 	}
	
		// });
	}
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-h-content a').on('click', function() {
        $('html').removeClass('is-open');
        scrollBan();
      });

      $('.js-mega-trigger').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).next('.js-mega-content').slideToggle();
      });

    } else {
      $('.js-mega-trigger').hover(function() {
        $(this).addClass('is-active');
        $(this).next('.js-mega-content').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).next('.js-mega-content').removeClass('is-active');
      });

      $('.js-mega-content').hover(function() {
        $(this).addClass('is-active');
        $(this).prev('.js-mega-trigger').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).prev('.js-mega-trigger').removeClass('is-active');
      });
    }
    
    // $(window).scroll(function () {
    //   if ($(window).scrollTop() > 20) {
    //     $('html').addClass('is-scroll');
    //   } else {
    //     if (!$('html').hasClass('is-open')) {
    //       $('html').removeClass('is-scroll');
    //     }
    //   }
    // });

    $(window).on('scroll', function () {

      const $html = $('html');
      const scrollTop = $(window).scrollTop();
      const $mv = $('.js-mv');
    
      // =========================
      // MVがある場合
      // =========================
      if ($mv.length) {
    
        const mvBottom = $mv.offset().top + $mv.outerHeight();
    
        if (scrollTop > mvBottom) {
          $html.addClass('is-scroll');
        } else {
          if (!$html.hasClass('is-open')) {
            $html.removeClass('is-scroll');
          }
        }
    
      } else {
    
        // =========================
        // MVがない場合（従来）
        // =========================
        if (scrollTop > 20) {
          $html.addClass('is-scroll');
        } else {
          if (!$html.hasClass('is-open')) {
            $html.removeClass('is-scroll');
          }
        }
    
      }
    
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    $('.js-menu-close').click(function () {
      $('html').removeClass('is-open');
      scrollBan();
    });

    let scrollTop = 0;

    function scrollBan() {
      const body = $('html')[0];
      if (body.classList.contains('is-hidden')) {
        body.style.scrollBehavior = 'auto';
        body.style.top = '';
        body.classList.remove('is-hidden');
        window.scrollTo(0, scrollTop);
        setTimeout(() => body.style.scrollBehavior = 'smooth', 0);
      } else {
        scrollTop = window.scrollY;
        body.style.top = (scrollTop * -1) + 'px';
        body.classList.add('is-hidden');
      }
    }

    if ($('.js-fixed-link').length > 0) {
      $(window).scroll(function() {
        if ($(window).scrollTop() + $(window).height() >= $('.js-footer').offset().top) {
          $('.js-fixed-link').addClass('is-hidden');
        } else {
          $('.js-fixed-link').removeClass('is-hidden');
        }
      });
    }

    if ($('.js-fixed-nav').length > 0) {
      $(window).on('scroll', function() {      
        const nav = $('.js-fixed-nav');
        const footer = $('.js-footer');
      
        const navBottom = nav.offset().top + nav.outerHeight();
        const footerTop = footer.offset().top;
      
        if (navBottom >= footerTop) {
          nav.addClass('no-active');
        } else {
          nav.removeClass('no-active');
        }
      });
    }
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-modal-trigger').on('click', function (e) {
      e.preventDefault();
      $('.js-modal').addClass('is-active');
			scrollBanOpen();
    });

    // 閉じる
    $('.js-modal-close, .js-modal-overlay').on('click', function (e) {
      $('.js-modal').removeClass('is-active');
			scrollBanClase();
    });
	}
}

class More {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		// const box = $(this).closest('.js-more-content');
    $('.js-more-btn').click(function(){
      $(this).addClass('is-active');
			$(this).parent('.js-more-area').addClass('is-active');
      $(this).closest('.js-more-content').css('height', 'auto');
      // $(this).toggleClass('is-active');
      // if($(this).hasClass("is-active")) {
      // } else {
      //   $(this).find('.js-more-text').text('続きを見る');
      //   $(this).parent('.js-more-content').css('height', '50rem');
      // }
    });  
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBanOpen() {
  const body = $('html')[0];
  // スクロール禁止
  scrollTop = window.scrollY;
  body.style.top = (scrollTop * -1) + 'px';
  body.classList.add('is-hidden');
}

function scrollBanClase() {
  const body = $('html')[0];
  // スクロール開放
  body.style.top = '';
  body.classList.remove('is-hidden');
  window.scrollTo(0, scrollTop);
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		if($(".js-gallery-swiper").length > 0){
			const galleryThumbs = new Swiper(".js-gallery-thum-swiper", {
				spaceBetween: 6,
				slidesPerView: "auto",
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				simulateTouch: false,
				slideToClickedSlide: false,
				breakpoints: {
					768: {
						spaceBetween: 10,
					},
				},
			});
			
			const gallery = new Swiper(".js-gallery-swiper", {
				centeredSlides: true,
				slidesPerView: "auto",
				loop: true,
				spaceBetween: 6,
				navigation: {
					nextEl: ".js-gallery-next",
					prevEl: ".js-gallery-prev",
				},
			
				thumbs: {
					swiper: galleryThumbs,
				},

				// simulateTouch: false,
				// preventClicks: true,
				// preventClicksPropagation: true,
	
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 8,
					},
				},
			});
			
			// document.querySelectorAll('.js-gallery-prev, .js-gallery-next').forEach(el => {
			// 	el.addEventListener('mousedown', (e) => {
			// 		// フォーカスだけ止める（クリックは殺さない）
			// 		if (e.button === 0) {
			// 			document.activeElement.blur();
			// 		}
			// 	});
			// });
		}

		if($(".js-point-swiper").length > 0){
			const pointSwiper = new Swiper(".js-point-swiper", {
				centeredSlides: false,
				slidesPerView: 1.5,
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 12,
				navigation: {
					nextEl: ".js-point-next",
					prevEl: ".js-point-prev",
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
				},
				on: {
					init: function () {
						updateCounter(this);
					},
					slideChange: function () {
						updateCounter(this);
					}
				}
			});

			function updateCounter(swiper) {

				if (window.innerWidth >= 768) return;
			
				const current = swiper.realIndex + 1;
				const total = swiper.el.querySelectorAll(
					'.swiper-slide:not(.swiper-slide-duplicate)'
				).length;
			
				document.querySelector(".js-point-current").textContent =
					String(current).padStart(2, "0");
			
				document.querySelector(".js-point-total").textContent =
					String(total).padStart(2, "0");
			
			}
		}

		if ($(".js-modelhouse-desc-swiper").length > 0) {
			const modelhouseDesc = new Swiper(".js-modelhouse-desc-swiper", {
				slidesPerView: "auto",
				spaceBetween: 10,
				loop: true,
				centeredSlides: true,
				navigation: {
					nextEl: '.js-modelhouse-next',
					prevEl: '.js-modelhouse-prev',
				},
				pagination: {
					el: '.js-modelhouse-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
					},
				},
			});			
		}
		if ($(".js-modelhouse-swiper").length > 0) {

			$(".js-modelhouse-swiper").each(function () {
		
				const $this = $(this);
		
				const swiper = new Swiper(this, {
					centeredSlides: false,
					slidesPerView: 1.1,
					loop: true,
					loopAdditionalSlides: 2,
					spaceBetween: 2,
					navigation: {
						nextEl: $this.find(".js-modelhouse-next")[0],
						prevEl: $this.find(".js-modelhouse-prev")[0],
					},
					pagination: {
						el: '.js-modelhouse-pagination',
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 1.5,
							spaceBetween: 4,
						},
					},
		
					on: {
						init: function () {
							updateModelhouseCounter(this, $this);
						},
						slideChange: function () {
							updateModelhouseCounter(this, $this);
						}
					}
		
				});
		
			});
		
			function updateModelhouseCounter(swiper, $el) {
		
				const current = swiper.realIndex + 1;
		
				const total = swiper.el.querySelectorAll(
					'.swiper-slide:not(.swiper-slide-duplicate)'
				).length;
		
				$el.find(".js-modelhouse-current").text(
					String(current).padStart(2)
				);
		
				$el.find(".js-modelhouse-total").text(
					String(total).padStart(2)
				);
		
			}
		
		}

		document.querySelectorAll('.js-view-swiper').forEach(el => {

			if (el.querySelectorAll('.swiper-slide').length === 0) return;
		
			new Swiper(el, {
				slidesPerView: "auto",
				spaceBetween: 2,
				loop: false,
				navigation: {
					nextEl: el.querySelector('.js-view-next'),
					prevEl: el.querySelector('.js-view-prev'),
				},
				pagination: {
					el: el.querySelector('.js-view-pagination'),
					clickable: true,
				},
			});
		
		});

		if($(".js-event-swiper").length > 0){
			const event = new Swiper(".js-event-swiper", {
				slidesPerView: "auto",
				spaceBetween: 10,
				loop: true,
				centeredSlides: true,
				navigation: {
					nextEl: '.js-event-next',
					prevEl: '.js-event-prev',
				},
				pagination: {
					el: '.js-event-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
					},
				},
			});
		}

		if($(".js-works-swiper").length > 0){
			const works = new Swiper(".js-works-swiper", {
				slidesPerView: "auto",
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 10,
				centeredSlides: true,
				speed: 1000,
				navigation: {
					nextEl: '.js-works-next',
					prevEl: '.js-works-prev',
				},
				pagination: {
					el: '.js-works-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 11,
					}
				},
			});
		}

		if($(".js-owner-swiper").length > 0){
			const owner = new Swiper(".js-owner-swiper", {
				slidesPerView: "auto",
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 10,
				centeredSlides: true,
				pagination: {
					el: '.js-owner-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
						centeredSlides: false,
					},
				},
				navigation: {
					nextEl: '.js-owner-next',
					prevEl: '.js-owner-prev',
				},
			});
		}

		if($(".js-blog-swiper").length > 0){
			const blog = new Swiper(".js-blog-swiper", {
				slidesPerView: "auto",
				loop: true,
				spaceBetween: 10,
				centeredSlides: true,
				pagination: {
					el: '.js-blog-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
						centeredSlides: false,
					},
				},
				navigation: {
					nextEl: '.js-blog-next',
					prevEl: '.js-blog-prev',
				},
			});
		}
	}
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		if($(".js-madori-thum").length > 0){
			$('.js-madori-thum li').on('click', function () {

				const imgSrc = $(this).find('img').attr('src');
		
				// メイン画像変更
				$('.js-madori-main img').attr('src', imgSrc);
		
				// active切替
				$('.js-madori-thum li').removeClass('is-active');
				$(this).addClass('is-active');
		
			});
		}

		// if($(".js-tab-content").length > 0){
		// 	$(".js-tab-content").each(function(){

		// 		const $wrap = $(this);
		// 		const $tabs = $wrap.prev().find(".js-tab-item");
		// 		const $contents = $wrap.children("div");
			
		// 		$tabs.removeClass("is-active").first().addClass("is-active");
		// 		$contents.hide().first().show();
			
		// 		$tabs.on("click", function(){			
		// 			const index = $(this).index();			
		// 			$tabs.removeClass("is-active");
		// 			$(this).addClass("is-active");
			
		// 			$contents.hide().eq(index).show();
			
		// 		});
			
		// 	});
		// }

		if($(".js-tab").length > 0){
			$(".js-tab").each(function(){

				const $wrap = $(this);
				const $tabs = $wrap.find(".js-tab-item");
				const $contents = $wrap.find(".js-tab-content");
			
				$tabs.removeClass("is-active").first().addClass("is-active");
				$contents.hide().first().show();
			
				$tabs.on("click", function(){

					const index = $tabs.index(this);
				
					$tabs.removeClass("is-active");
					$(this).addClass("is-active");
				
					$wrap.find(".js-tab-content").hide();
					$wrap.find(".js-tab-content").eq(index).show();
				
				});
			
			});
		}
	}
}


(() => {
  let top = new Top('p-top');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let headerMenu = new HeaderMenu('js-header');
  let modal = new Modal('js-modal');
  let slider = new Slider('js-swiper');
  let tab = new Tab('js-tab');
  let accordion = new Accordion('js-acc-trigger');
  let fixedArea = new FixedArea('js-fixed-area');
  let more = new More('js-more-btn');
  let form = new Form('c-contact');
  $(document).ready(function () {
    new ScrollHint('.js-scrollable',{
      i18n: {
        scrollable: "スクロールできます",
      }
    });
  });
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});

(() => {
  if (!location.hash) return;

  const html = document.documentElement;
  const prev = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";

  // 1～2フレーム待つ（iOSの再レイアウト対策）
  setTimeout(() => {
    const el = document.querySelector(location.hash);
    if (el) el.scrollIntoView();
    html.style.scrollBehavior = prev;
  }, 500);
})();